export default __webpack_public_path__ + "static/media/steven-min.3282c267.png";